import React from "react";
import "./billy-cook-brand.css";

/**
 * Heritage strip aligned with Genuine Billy Cook positioning:
 * Oklahoma craftsmanship, Western performance, premium tack.
 */
const BillyCookBrandSection = () => {
  return (
    <section className="billycook-brand-section" aria-labelledby="billycook-brand-heading">
      <div className="billycook-brand-inner">
        <p className="billycook-brand-eyebrow">Since 1953 · Sulphur, Oklahoma</p>
        <h2 id="billycook-brand-heading" className="billycook-brand-title">
          Genuine Billy Cook Western saddles
        </h2>
        <p className="billycook-brand-body">
          Hand-built trees, rich leathers, and the kind of balance riders expect in the
          arena and on the ranch. Each piece reflects decades of saddle-making tradition—designed
          to ride, built to last.
        </p>
      </div>
    </section>
  );
};

export default BillyCookBrandSection;
